import type {StateCreator} from 'zustand';

import type {ContentDiscoveryStoreState} from 'client/components/ContentDiscovery/store/ContentDiscoveryStore.types';

type SaveState = {
  autoSave: boolean;
};

type SaveActions = {
  hasUnsavedChanges: () => boolean;
  reset: () => void;
};

export type SaveSlice = SaveState & SaveActions;

const initialState: SaveState = {
  autoSave: false
};

export const createSaveSlice: StateCreator<
  ContentDiscoveryStoreState,
  [['zustand/immer', never]],
  [],
  SaveSlice
> = (set, get) => ({
  ...initialState,

  hasUnsavedChanges: () => {
    const {selectedQuestionSets} = get().draft;
    return selectedQuestionSets.size > 0;
  },

  reset: () => {
    set((state) => {
      state.save = {...state.save, ...initialState};
    });
  }
});
